<template>
  <CContainer>
    <CRow>
      <h6>
        Esta sección permite visualizar los pedidos que han sido cargados por lo usuarios y que estan pendientes de Aprobación. Desde esta sección podrá verificar, imprimir, aprobar y modificar los Pedidos cargados y NO autorizados. 
      </h6>
    </CRow>
        <CCard class="mt-4">
          <CCardBody class="p-3">
            <CDataTable
                :items="items.filter((item)=> (item.Estado_Pedido == 'CA') || (item.Estado_Pedido == 'PA'))"
                :fields="fields"
                :tableFilter="{ label: 'Buscar:', placeholder:' ' }"
                :items-per-page="10"
                hover
                pagination>
                <template #Numero="{item}">
                  <td>
                    <div class="d-flex justify-content-end">
                      <h4>{{ item.Numero }}</h4>
                    </div>
                  </td>
                </template>
                <template #Fecha_Emision="{item}">
                  <td>
                    <div class="d-flex justify-content-end">
                      <CIcon name="cil-calendar" class="mr-1" />
                      {{item.Fecha_Emision}}
                    </div>
                  </td>
                </template>
                <template #Valor_Total="{item}">
                  <td>
                    <div class="d-flex justify-content-end">
                      {{ formatter.format(item.Valor_Total, 0) }}
                    </div>
                  </td>
                </template>
                <template #Estado_Pedido="{item}">
                  <td>
                    <span v-if="item.Estado_Pedido === 'CA'">Cargado</span>
                    <span v-if="item.Estado_Pedido === 'AU'">Autorizado</span>
                    <span v-if="item.Estado_Pedido === 'PE'">Pendiente</span>
                    <span v-if="item.Estado_Pedido === 'PA'">Pendiente Aprobación</span>
                    <span v-if="item.Estado_Pedido === 'EM'">Entregado</span>
                    <span v-if="item.Estado_Pedido === 'TO'">Total</span>
                    <span v-if="item.Estado_Pedido === 'AL'">Alistamiento</span>
                  </td>
                </template>
                <template #setApproval="{item}">
                  <td>
                    <a href="#" 
                      class="mr-2" @click="(event) => activeRightSideBarOrderDetail(event, item.Id_Pedido)">
                      <CIcon name="cil-clipboard" class="dark" size="lg"/>
                    </a>
                    <a href="#"
                      class="mr-2"
                      @click="activeConfirm(item.Id_Pedido, true)">
                      <CIcon name="cil-thumb-up" class="text-success" size="lg"/>
                    </a>
                    <a href="#"
                      class="mr-2"
                      @click="activeConfirm(item.Id_Pedido, false)">
                      <CIcon name="cil-thumb-down" class="text-danger" size="lg"/>
                    </a>
                    <a href="#"
                      class="mr-2"
                      @click="printDocumentPDF(item.Id_Pedido)">
                      <CIcon name="cib-adobe-acrobat-reader" class="text-danger" size="lg"/>
                    </a>
                    
                    <a v-if="false"
                      href="#"
                      class="mr-2" >
                      <CIcon name="cil-cloud-download" class="text-info" />
                    </a>
                  </td>
                </template>
            </CDataTable>
          </CCardBody>
        </CCard>

        <CElementCover v-if="loading"/>

        <RightSideBar size="lg" class="bg-s3grey" :show="showOrderDetail">
          <CContainer>
            <CCard>
              <CCardHeader>
                <CCardTitle>
                  Movimiento de Pedido
                </CCardTitle>
                <CCardSubtitle>
                  <small>Detalle de los productos solicitados en el Pedido.</small>
                </CCardSubtitle>
              </CCardHeader>
              <CCard>
                <OrderQuoteDetail :idOrderQuote="idPedido"  :key="updateComponent" />
              </CCard>
              <CCardFooter>
                <div class="d-flex justify-content-center">
                  <CButton
                    class="d-inline-block"
                    color="secondary"
                    @click="showOrderDetail=false">
                    <CIcon name="cil-x-circle" class="mr-2"/>
                    Cerrar
                  </CButton>
                </div>
              </CCardFooter>
            </CCard>
          </CContainer>
        </RightSideBar>

        <CModal
          title="¡Confirmación!"
          color="warning"
          :show.sync="activeConfirmationModal"
          :centered="true"
          :closeOnBackdrop="false"
          :backdrop="true"
          >
          <template v-slot:body-wrapper>
            <CContainer class="d-flex justify-content-center p-4">
              <p>¿Confirma que desea {{ isApproved ? "aprobar" : "rechazar" }} este Pedido?</p>
            </CContainer>
          </template>
          <template v-slot:footer>
            <CContainer class="d-flex justify-content-center">
              <CButton
                class="mr-3 d-inline-block"
                :color="isApproved ? 'success' : 'danger'"
                @click="setApprove()">
                <CIcon :name="isApproved ? 'cil-thumb-up' : 'cil-thumb-down'" class="mr-2"/>
                {{ isApproved ? "Aprobar" : "Rechazar" }}
              </CButton>
              <CButton
                class="d-inline-block"
                color="secondary"
                @click="activeConfirmationModal=false">
                <CIcon name="cil-x-circle" class="mr-2"/>
                Cancelar
              </CButton>
            </CContainer>
          </template>
        </CModal>
    </CContainer>
</template>

<script>
  import constants from '../../constants'
  import { formatter } from '../../general'
  import RightSideBar from "../containers/RightSideBar.vue";
  import OrderQuoteDetail from '../datagrids/OrderQuoteDetail.vue'
  import { 
    downloadFileObject, 
    dataGridPedidos, 
    actualizaPedido 
  } from '../../api'
  import { descargarCotizacionPDF } from '../../apiReports'
  
  const fields = [
    { key: 'Numero', label:'Número', _style: 'text-align:center;'},
    { key: 'Dependencia', _style: 'text-align:center;'},
    { key: 'Fecha_Emision', label:'Fecha', _style: 'text-align:center;'},
    { key: 'Valor_Total', label:'Valor Total', _style: 'text-align:center;'},
    { key: 'Estado_Pedido', label:'Estado', _style: 'text-align:center;'},
    { key: 'setApproval', label:'', _style: 'text-align:center;'},
  ]

  export default {
    name: 'PendingOrders',
    data () {
      return {
        formatter,
        loading: false,
        items: [],
        fields,
        details: [],
        detailModal: false,
        activeConfirmationModal: false,
        showOrderDetail: null,
        updateComponent: 0,
        idPedido: "",
        isApproved: false
      }
    },
    components: { 
      RightSideBar,
      OrderQuoteDetail 
    },
    methods:{
      async getData() {
        try {
          this.loading = true
          const { response } = await dataGridPedidos(
            this, 
            this.$store.state.user.data.id_Directorio
          )
          this.items = response
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async printDocumentPDF(idDocument) {
        this.loading = true

        try {
          const { response } = await descargarCotizacionPDF(this, idDocument)
          const { nombreArchivo, contenidoArchivo } = response

          downloadFileObject(nombreArchivo, "pdf", contenidoArchivo)

          // const dataBase64 = await imprimirCotizacion(this, idDocument)
          // const url = URL.createObjectURL(new Blob([dataBase64], { type: "application/vnd.pdf" }))
          // const link = document.createElement("a")
          // link.href = url
          // link.setAttribute("download", "fileName.pdf")
          // document.body.appendChild(link)
          // link.click()
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al generar el archivo PDF.",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      activeRightSideBarOrderDetail(e, idPedido) {
        e.stopPropagation();

        this.idPedido = idPedido;
        this.showOrderDetail = true;
        this.updateComponent += 1;
      },
      activeConfirm(idPedido, isApproved) {
        this.idPedido = idPedido
        this.isApproved = isApproved
        this.activeConfirmationModal = true
      },
      async setApprove() {
        try {          
          this.loading = true
          const {response} = await actualizaPedido(
            this,
            {
              "Id_Pedido": this.idPedido,
              "Aprobacion": this.isApproved,
              "Id_Usuario": this.$store.state.user.data.id_Usuario
            }
          )
          
          const item = this.items.find(item => item['Id_Pedido'] === response['id_Pedido'])
          
          if (item) {
            item['Estado_Pedido'] = response['estado_Pedido']
          }

          this.activeConfirmationModal = false
          this.$store.commit('setAlert', {
            color: "success",
            message: 'Acción exitosa',
            show: 5
          })
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: constants.messages.notDoneEdit,
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    }, 
    mounted(){
      this.getData()
    }  
  }
</script>